import React from 'react';
import ShowroomLocatorContent from 'components/consumer/consumer-new-footer/components/ShowroomLocatorContent';

const NavbarShowroomLocator = () => (
  <div className="w-[320px] lg:w-[350px] min-[1440px]:w-[400px] px-4 py-3">
    <div className="text-sm text-gray mb-2 font-bold text-lg">
      Find your closest showroom
    </div>
    <ShowroomLocatorContent inputId="navbar-showroom-zipcode" />
  </div>
);

export default NavbarShowroomLocator;
